import React, {Component, PropTypes} from 'react';
import {observer, inject} from 'mobx-react';
import {observable, action, toJS, autorun} from 'mobx';
import Modal from '../Modal';
import Form, {FormBody, FormActions, TextInput} from '../Form';
import DragAndDrop from "../DragAndDrop";
import {tag as api} from '../../actions/api';

@inject('tagStore', 'parameterStore')
@observer
class TagParameter extends Component {
  // static propTypes = {
  // route: PropTypes.shape().isRequired,
  // params: PropTypes.shape({
  // id: PropTypes.string.isRequired,
  // }).isRequired,
  // tagStore: PropTypes.object.isRequired,
  // };

  static contextTypes = {
    router: PropTypes.object.isRequired,
    notify: PropTypes.object.isRequired,
  };

  slug = '/tag';
  title = 'Tag Parameters';
  disposer = null;
  @observable item = {
    name: '',
    description: '',
  };

  constructor(props) {
    super(props);

    const {params: {id}, tagStore, parameterStore} = props;

    if (!parameterStore.items.length) parameterStore.fetchItems();
    tagStore.fetchItem(id);
  }

  componentWillMount() {
    const {params: {id}, tagStore} = this.props;
    this.disposer = autorun(() => {
      const foundTag = tagStore.findById(id);
      if (foundTag) {
        this.item = foundTag.asJson;
      }
    })
  }


  @action  onChangeMetaData = (dndLists) => {
    const parameterList = dndLists.slice(-1).pop();
    const parameters = parameterList.items;

    this.item.parameters = parameters.map((item, i) => (Object.assign(item, {seq: i + 1})));
  };

  handleSave = (e) => {

    e.preventDefault();

    const {params: {id}} = this.props;
    const {notify} = this.context;

    api.parameterUpsert(id, this.item.parameters.map(item => ({tag_id: id, parameter_id: item.id, seq: item.seq})))
      .then(() => {
        this.context.router.push(this.slug);
        notify.success();
      })
      .catch(err => {
        notify.error(err);
      });
  };

  render() {
    const {tagStore, parameterStore, params: {id}} = this.props;

    // console.log(toJS(this.item));

    return (
      <Modal title={this.item.name || this.title} slug={this.slug} isSaving={tagStore.isSaving || parameterStore.isSaving} handleSave={this.handleSave} isLoading={tagStore.isLoading || parameterStore.isLoading}>
        <Form>
          <FormBody>
            <DragAndDrop
              lists={[{
                id: 1,
                name: 'Parameter List',
                items: toJS(parameterStore.items),
              }, {
                id: 2,
                name: 'Tag Parameters',
                // dndItems: metaDataItems,
                items: this.item.parameters || [],
                // items: [
                // // { id: 999, name: 'Dummy' },
                // ],
              }]}
              onChange={this.onChangeMetaData}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default TagParameter;



// WEBPACK FOOTER //
// ./src/components/Tag/TagParameter.js